import { ParticipantDocumentApprovalStatusEnum } from './participant-document-approval-status-enum.generated';

const x: { [index: string]: string } = {};
x[ParticipantDocumentApprovalStatusEnum.Unknown] = 'Unknown';
x[ParticipantDocumentApprovalStatusEnum.Approved] = 'Approved';
x[ParticipantDocumentApprovalStatusEnum.Denied] = 'Denied';
export const ParticipantDocumentApprovalStatusEnumDescriptions: { [indexer: string]: string } = x;
